import axios from "./axios"

/**
 * 檢查的士服務准入條件,並返回支付信息
 * @param {*} serviceType 
 * @param {*} identType 
 * @param {*} identNo 
 * @param {*} taxiCertNo 
 */
const check = (serviceType, identType, identNo, taxiCertNo) => {
    return axios.post(`/protected/api/v1/application/taxi/${serviceType}?identType=${identType}&identNo=${identNo}&taxiCertNo=${taxiCertNo}`).then(res => res.data)
}

/**
 * 查詢歷年繳費記録
 * @param {*} serviceType 
 * @param {*} identType 
 * @param {*} identNo 
 */
const history = (serviceType, identType, identNo, ) => {
    return axios.post(`/protected/api/v1/application/taxi/history/${serviceType}?identType=${identType}&identNo=${identNo}`).then(res => res.data)
}


export default {
    check,
    history
}